import React from "react";
import Maps from "../components/Maps";
import Header from "../components/Header";

function Gamemode() {
  return (
    <div>
      <Header />
      <Maps />
    </div>
  );
}

export default Gamemode;
